<app-header></app-header>
<div class="aa-container">
   <div class="row">
    <div class="col-md-4 d-none d-md-block ps-md-5">
        <app-common-desktop-sidebar></app-common-desktop-sidebar>
    </div>
    <div class="col-12 col-md-8 desktop-container">
      <div class="w-100">
        <router-outlet></router-outlet>
      </div>
    </div>
   </div>
</div>
<app-footer></app-footer>